import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { kFormatter } from "../../constants/function";
import "./index.scss";
import { useTranslation } from "react-i18next";

export default function SongNft({ value, musicDetail }) {
  const { t } = useTranslation("common");
  return (
    <Box className="float">
      {/* {console.log(value, "::value::")} */}
      <Box className="_record_main">
        <img
          className="_record_t"
          src={value?.recordData?.recordImg}
          alt={value?.recordData?.recordName}
        />
        <Stack
          className="_record_level_t"
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          {[...Array(value?.recordData?.level)].map((level, index) => (
            <img
              key={index}
              className="_record_xt"
              src={value?.recordData?.recordImg}
              alt=""
            />
          ))}
        </Stack>
      </Box>
      <Stack>
        <Typography className="fs-18 ">
          {kFormatter(musicDetail["listens"])}
          <span className="fs-13 fade-text-60" style={{ marginLeft: "2px" }}>
            {t("myCollection.nftCard.stream")}
          </span>
        </Typography>
        <Typography className="fs-14 ">
          {value && value["recordData"] && value["recordData"]["recordName"]}
          <span className="fs-14 "> {t("myCollection.nftCard.record")}</span>
        </Typography>
      </Stack>
    </Box>
  );
}
